<template>
 <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">出入园数据</div>
      </zj-layout-header>
      <div style="height:50%">
        <div style="margin-left:3%;">
          <el-form>
            <el-form-item label="日期">
              <el-date-picker placeholder="选择日期" v-model="BeginDay" @change="selectDay"></el-date-picker>
            </el-form-item>
          </el-form>
        </div>
        <div  style="height:85%;margin-left:3%;">
            <div id="echart-line-day" style="width: 100%;height: 100%;"></div>
        </div>
      </div>
      <div style="height:50%">
        <div style="margin-left:3%;">
          <el-form>
            <el-form-item label="月份">
              <el-date-picker placeholder="选择月份" v-model="BeginMonth" value-format="yyyy-MM" type="month" @change="selectMonth" ></el-date-picker>
            </el-form-item>
          </el-form>
        </div>
        <div  style="height:85%;margin-left:3%;">
          <div id="echart-line-month" style="width: 100%;height: 100%;"></div>
        </div>
      </div>
    </zj-layout-container>
  </div>
</template>
<script>

import MyApis from "../../../apis";
import * as echarts from "echarts"

export default {
  name: "TicketOutandInView",
  controller: "UI",
  action: "TicketOutandInView",
  components: {
  },
  data() {
    return {
      loading: false,
      loadingText: '加载中...',
      BeginDay: new Date(),
      BeginMonth: new Date().format("yyyy-MM"),
    };
  },
  mounted: function () {
    this.selectDay();
    this.selectMonth();
  },
  methods: {
    selectDay() {
      let that = this;
      let searchInfo = {
        BeginTime:
          this.BeginDay == null
          ? "0001-01-01T00:00:00"
          : this.BeginDay.format("yyyy-MM-dd 00:00:00"),
        EndTime:
          this.BeginDay == null
          ? "0001-01-01T00:00:00"
          : this.BeginDay.format("yyyy-MM-dd 23:59:59"),
      };
      new MyApis.TicketApi()
      .GetTourist_FlowStat_TimePeriod(searchInfo) //到时候需要换成大数据那边的接口
      .then((r) => {
        r = r.data.Data;
              
        that.drawDayChart(r);
      })
      .catch((e) => {
        console.log(e);
        that.$message({
          type: "error",
          message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
        });
      });
    },
    drawDayChart(data) {
      if(data)
      {
        var COLORS = ['#47f4de',  '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'];
        var myDayChart = echarts.init(document.getElementById('echart-line-day'));
        var colors = COLORS.slice(parseInt(Math.random() * COLORS.length / 2));
        myDayChart.setOption({
          color:colors,
          title: {
            show: true,
            text: "日客流走势",
            textStyle: {
              color: '#fff'
            }
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: ['2020', '2021'],
            textStyle: {
              color: '#fff'
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: ['0时', '1时', '2时', '3时', '4时', '5时', '6时','7时','8时','9时','10时', '11时', '12时', '13时', '14时', '15时', '16时','17时','18时','19时','20时', '21时', '22时', '23时'],
            axisLabel:{
              color: '#fff'
            },
            axisLine:{
              lineStyle:{
                color: '#fff',
                width: 1,
              }
            }
          },
          yAxis: {
            type: 'value',
            splitLine: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff'
              }
            },
            axisLine:{
              lineStyle: {
                color: '#fff',
                width: 1,
              }
            }
          },
          series:[  //现在为写死的数据 到时候需要换成大数据那边接口的数据
            { 
              name: "2020",
              type: 'line',
              data: [120, 132, 101, 134, 90, 230, 210,220, 182, 191, 234, 290, 330, 310,150, 232, 201, 154, 190, 330, 410, 201, 154, 190]
            },
            { 
              name: "2021",
              type: 'line',
              data: [320, 332, 301, 334, 390, 330, 320,120, 132, 101, 134, 90, 230, 210,120, 132, 101, 134, 90, 230, 210, 310,150, 232]
            }
          ]
        })
      }     
    },
    selectMonth() {
      let that = this;
      var year = this.BeginMonth.split("-")[0];
      var month = this.BeginMonth.split("-")[1];
      var lastDay=new Date(year,month,0);
      var day = lastDay.getDate();
      day = day < 10 ? '0'+day : day;
      let searchInfo = {
        BeginTime:
          this.BeginMonth == null
          ? "0001-01-01T00:00:00"
          : year + '-' + month + "-01 00:00:00",
        EndTime:
          this.BeginMonth == null
          ? "0001-01-01T00:00:00"
          : year + '-' + month + '-' + day + " 23:59:59",
      };
      new MyApis.TicketApi()
      .GetTourist_FlowStat_TimePeriod(searchInfo) //到时候需要换成大数据那边的接口
      .then((r) => {
        r = r.data.Data;
              
        that.drawMonthChart(r,day);
      })
      .catch((e) => {
        console.log(e);
        that.$message({
          type: "error",
          message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
        });
      });
    },
    drawMonthChart(data,day) {
      if(data)
      {
        var COLORS = ['#47f4de',  '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'];
        var myMonthChart = echarts.init(document.getElementById('echart-line-month'));
        var colors = COLORS.slice(parseInt(Math.random() * COLORS.length / 2));
        var timeArr=[];
        for(let i=1;i<=day;i++){
          timeArr.push(i+'日');
        }
        myMonthChart.setOption({
          color:colors,
          title: {
            show: true,
            text: "月客流走势",
            textStyle: {
              color: '#fff'
            }
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: ['2020', '2021'],
            textStyle: {
              color: '#fff'
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: timeArr,
            axisLabel:{
              color: '#fff'
            },
            axisLine:{
              lineStyle:{
                color: '#fff',
                width: 1,
              }
            }
          },
          yAxis: {
            type: 'value',
            splitLine: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff'
              }
            },
            axisLine:{
              lineStyle: {
                color: '#fff',
                width: 1,
              }
            }
          },
          series:[  //现在为写死的数据 到时候需要换成大数据那边接口的数据
            { 
              name: "2020",
              type: 'line',
              data: [120, 132, 101, 134, 90, 230, 210,220, 182, 191, 234, 290, 330, 310,150, 232, 201, 154, 190, 330, 410, 201, 154, 190, 190, 330, 410, 201, 154, 190]
            },
            { 
              name: "2021",
              type: 'line',
              data: [320, 332, 301, 334, 390, 330, 320,120, 132, 101, 134, 90, 230, 210,120, 132, 101, 134, 90, 230, 210, 310,150, 232, 90, 230, 210, 310,150, 232]
            }
          ]
        })
      }     
    },
  }
}

</script>